export default [
  {
    title: 'Security',
    icon: 'fas fa-shield-alt',
    children: [{ path: '/users', title: 'User' }]
  },
  {
    title: 'Administration',
    icon: 'fas fa-th',
    children: [
      { path: '/company-profiles', title: 'Company' },
      { path: '/divisions', title: 'Division' },
      { path: '/departments', title: 'Department' },
      { path: '/positions', title: 'Position' },
      { path: '/customer-zones', title: 'Customer Zone' },
      { path: '/customer-profiles', title: 'Customer Profile' },
      { path: '/employee-profiles', title: 'Employee Profile' },
      { path: '/currencies', title: 'Currency' },
      { path: '/service-locations', title: 'Service Location' }
    ]
  },
  {
    title: 'Expense',
    icon: 'far fa-money-bill-alt',
    children: [
      { path: '/expense-items', title: 'Expense Item' },
      { path: '/expense-records', title: 'Expense Record' },
      { path: '/beginning-balances', title: 'Beginning Balance' },
      { path: '/exchange-transactions', title: 'Exchange Transaction' },
      { path: '/rate-informations', title: 'Rate Information' }
    ]
  }
]
